const hasDeveloperSwitch = require("./hasDeveloperSwitch");
const events = require("add-event-listener");
const environment = require("../../../ENV")["environment"];
const handlers = {};

class PostMessageProcessor
{
    static init(application, parentDomain)
    {
        this.processMessageEvent(application);
        if(parentDomain){
            window.parent.postMessage({
                     destination: 'clientWebsite',
                     event: 'isOnline',
                     payload: application
                 }
             , parentDomain)
        }
    }

    static processMessageEvent(application)
    {
        events.addEventListener(window, "message", function(e) {

            const destination = e.data.destination;
            const event = e.data.event;
            const payload = e.data.payload;

            if (destination === application || destination === "*")
            {
/*
                if (environment !== "production" || hasDeveloperSwitch())
                {
                    const details = {
                        destination: application,
                        event: event,
                        isEventHandlerRegistered: handlers[event] !== undefined,
                        payload: payload
                    };

                    if (details.isEventHandlerRegistered === false)
                    {
                        console.log(details);
                    }
                }
*/

                if (handlers[event])
                {
                    handlers[event](payload);
                }
            }

        });
    }

    static register(event, handler)
    {
        handlers[event] = handler;
    }
}

export default PostMessageProcessor



// WEBPACK FOOTER //
// ./common/js/lib/PostMessageProcessor.js